var _rect, _g, _rect2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountInside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155.9px",
    height: "195px",
    viewBox: "0 0 155.9 195",
    enableBackground: "new 0 0 155.9 195",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.1,
    fill: "#FFFFFF",
    width: 155.9,
    height: 195.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 30,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 106.3,
    height: 147.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 88.8,
    height: 130
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 39.8,
    fill: "#474746",
    width: 0,
    height: 9.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7593,
    strokeMiterlimit: 10,
    d: "M36,145c0,0,0,2.6-0.4,3.7 c-0.7,1.8,0.5,2.3,0.5,2.3h85c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H36L36,145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7593,
    strokeMiterlimit: 10,
    d: "M36,139.7c0,0,0.1,1.9-0.4,3.7 c-1.1,2.3,0.5,2.3,0.5,2.3h85c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H36L36,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7593,
    strokeMiterlimit: 10,
    d: "M38.6,40.1h82.7l-0.3,90.3 c0,0,0.1,1.1,0,4.3c0.5,1.9,1,5.3-0.5,5.3c-1.6,0-79.7,0-83.8,0c-2.9,0-0.9-2.9-1.2-8.8c0-1.4,0-91.1,0-91.1L38.6,40.1L38.6,40.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountInside);
export default __webpack_public_path__ + "static/media/mount_inside.bfc4874711a1ad499d39616b6ad8b5ef.svg";
export { ForwardRef as ReactComponent };